import { isEqual } from "lodash";
import { useRef } from "react";

export default function useDeepMemo<V>(value: V): V {
  const ref = useRef(value);
  if (!isEqual(value, ref.current)) ref.current = value;
  return ref.current;
}
